import axiosInstance from "../../axiosInstance";
const BASE_URL = "/elearning/subjects";

/**
 * =====================================================
 * GET – Lấy danh sách môn học (có lọc)
 * =====================================================
 * filters: { keyword, status }
 */
export const getAllSubjects = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value);
      }
    });

    const res = await axiosInstance.get(
      `${BASE_URL}?${params.toString()}`
    );

    return res.data;
  } catch (error) {
    console.error("Lỗi khi lấy danh sách môn học:", error);
    throw error;
  }
};

/**
 * =====================================================
 * GET – Lấy tất cả môn học (KHÔNG phân trang)
 * =====================================================
 */
export const getAllSubjectsNoPaging = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value);
      }
    });

    const res = await axiosInstance.get(
      `${BASE_URL}/no-paging?${params.toString()}`
    );

    return res.data;
  } catch (error) {
    console.error("Lỗi khi lấy môn học (no-paging):", error);
    throw error;
  }
};

/**
 * Danh sách môn học cho dropdown / bộ lọc (học viên, lớp, khóa học, tài liệu, …).
 * Không yêu cầu quyền elearning.subjects R — chỉ cần R trên module đang dùng.
 */
export const getSubjectsLookup = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        params.append(key, value);
      }
    });

    const res = await axiosInstance.get(
      `${BASE_URL}/lookup?${params.toString()}`
    );

    return res.data;
  } catch (error) {
    console.error("Lỗi khi lấy môn học (lookup):", error);
    throw error;
  }
};

/**
 * =====================================================
 * GET – Lấy chi tiết môn học theo ID
 * =====================================================
 */
export const getSubjectById = async (id) => {
  try {
    const res = await axiosInstance.get(`${BASE_URL}/${id}`);
    return res.data;
  } catch (error) {
    console.error("Lỗi khi lấy chi tiết môn học:", error);
    throw error;
  }
};

/**
 * =====================================================
 * POST – Tạo môn học mới
 * =====================================================
 */
export const createSubject = async (data) => {
  try {
    const res = await axiosInstance.post(BASE_URL, data);
    return res.data;
  } catch (error) {
    console.error(
      "Lỗi khi tạo môn học:",
      error.response?.data || error.message
    );
    throw new Error(
      error.response?.data?.message || "Không thể tạo môn học"
    );
  }
};

/**
 * =====================================================
 * PUT – Cập nhật môn học
 * =====================================================
 */
export const updateSubject = async (id, data) => {
  try {
    const res = await axiosInstance.put(`${BASE_URL}/${id}`, data);
    return res.data;
  } catch (error) {
    console.error(
      "Lỗi khi cập nhật môn học:",
      error.response?.data || error.message
    );
    throw new Error(
      error.response?.data?.message || "Không thể cập nhật môn học"
    );
  }
};

/**
 * =====================================================
 * PATCH – Bật / tắt trạng thái môn học
 * =====================================================
 */
export const toggleSubjectStatus = async (id, status) => {
  try {
    const res = await axiosInstance.patch(
      `${BASE_URL}/${id}/status`,
      { status }
    );
    return res.data;
  } catch (error) {
    console.error("Lỗi khi cập nhật trạng thái môn học:", error);
    throw new Error("Không thể cập nhật trạng thái môn học");
  }
};

/**
 * =====================================================
 * DELETE – Xóa môn học
 * =====================================================
 */
export const deleteSubject = async (id) => {
  try {
    const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
    return res.data;
  } catch (error) {
    console.error("Lỗi khi xóa môn học:", error);
    throw new Error(
      error.response?.data?.message || "Không thể xóa môn học"
    );
  }
};
